<template>
  <span class="lp-avatar" :style="style">
    <img v-if="photo" :src="photo" :alt="name || ''" loading="lazy">
    <template v-else>{{ initials }}</template>
  </span>
</template>

<script>
import { initials, avatarGradient } from './presenter'

/**
 * Presenter avatar — the photo when the person has one, their initials on a
 * stable brand-tinted gradient otherwise. Every presenter surface (drawer rows,
 * faculty modal cards, faculty drawer portrait) renders the same fallback, so
 * the photo/initials decision lives here rather than in each host.
 *
 * Only the intrinsic bits are styled here (round, clipped, centred, white
 * text). Size, font-size and spacing stay with the host's own class — the
 * consumer puts it on this component and Vue applies it to the root element:
 *
 *   <lp-avatar class="faculty-avatar" :name="f.name" :photo="f.photo" />
 */
export default {
  name: 'lp-avatar',

  props: {
    name: { type: String, default: '' },
    photo: { type: String, default: '' },
  },

  computed: {
    initials() {
      return initials(this.name)
    },

    // The gradient is a background, so it must not be painted under a photo.
    style() {
      return this.photo ? null : { background: avatarGradient(this.name) }
    },
  },
}
</script>

<style lang="scss" scoped>
.lp-avatar {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 500;
  letter-spacing: 0.02em;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
